// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';
import {selx} from 'clsx';

import {ProfileActivityEl} from 'common/widgets/profile-activity';
import {ProfileUserSummaryEl} from 'common/widgets/profile-user-summary';
import {ToggleEl} from 'common/components/toggle';
import {ToggleTheme} from 'common/components/toggle/types';

import {ProfileDemographicsEl} from '../profile-demographics';
import type {ProfileSidebar} from './index';
import {UserDetailTab} from './types';
import toggleOverride from './toggle-override.inline.styl';

export function template(this: ProfileSidebar) {
  const isDataGroup = !!this.attr(`data-group-id`);
  return (
    <div
      sel={selx(`profile-sidebar-container`, {
        'for-right-drawer': !!this.attr(`for-right-drawer`),
      })}
      style={{width: `${this.attr(`width`)}px`}}
    >
      <div sel='.profile-sidebar-header' />

      <div sel='.profile-sidebar-summary'>
        <ProfileUserSummaryEl attrs={this.helpers.getUserSummaryAttrs()} />
      </div>

      <div sel='.profile-sidebar-tabs'>
        <ToggleEl
          attrs={{
            theme: ToggleTheme.TabBar,
            selected: this.state.selectedTab,
            'style-override': toggleOverride,
            options: [
              {label: `Activities`, value: UserDetailTab.Activities},
              {label: isDataGroup ? `Group Properties` : `User Properties`, value: UserDetailTab.Properties},
            ],
          }}
          on={{
            select: this.handleTabSelect,
          }}
        />
      </div>

      <div sel='.profile-sidebar-body'>
        {this.state.selectedTab === UserDetailTab.Properties && (
          <ProfileDemographicsEl attrs={this.helpers.getUserDemographicAttrs()} />
        )}
        {this.state.selectedTab === UserDetailTab.Activities && (
          <ProfileActivityEl attrs={this.helpers.getUserActivityAttrs()} />
        )}
      </div>
    </div>
  );
}
